import React,{useState, useEffect} from 'react';
import {Input} from '../../styles/CommonStyles';
import {Cabecalho,DadosPagamento} from './StyledPrepagamento';
import {Button, SpanButton} from '../../pages/postEdit/stylePostEdit';
import Toastify from '../../components/Toastify';
import Axios from 'axios';
import pagarme  from 'pagarme';
import {getprice}from '../../services/servicesGetPrices';
import Recaptcha from 'react-google-recaptcha';

export default function Prepagamento(){

    const api = Axios.create({
        baseURL: `https://app6.medx.med.br/api/stone`,
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Expose-Headers": "Access-Control-*",
            "Access-Control-Allow-Headers": "Access-Control-*, Origin, X-Requested-With, Content-Type, Accept",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS, HEAD",
            "Access-Control-Allow-Origin": "*",

        }
    });


    const [EndpointURL, setEndpointURL] = useState('');
    const ProducaoURL = 'https://xdem.app/api/stone';
    const TesteURL = 'https://app6.medx.med.br/api/stone';
    const [EncryptionKey, setEncryptionKey] = useState('');

    const TesteEncryptionKey = 'ek_test_AkZrPbYYBMrX34gv4AbG45J8g1oseM';
    const ProducaoEncryptionKey = 'ek_live_C68Tv4dHUWmg8yY2IXfDzSDxv6nATk';

    const [dadosPerfil, setDadosPerfil] = useState({
        nome:JSON.parse(localStorage.getItem('currentUser')).Name  ||'',
        price:''
    });
    const [dadosPagamento, setDadosPagamento] = useState({
        numeroCartao:'',
        parcelas:'1',
        nome:'',
        validadeMes:'',
        validadeAno:'',
        codigoSeguranca:'',
    });
    const [dadosPagador, setDadosPagador] = useState({
        nomeCompleto:'',
        cpfcnpj:'',
        nascimento:'',
        email:'',
        telefone:'',
        cep:'',
        logradouro:'',
        numero:'',
        bairro:'',
        cidade:'',
        estado:'',
    });

    const [captcha, setCaptcha] = useState(false);

    async function PegaValorAPagar(){
        const data = await getprice();
        setDadosPerfil({...dadosPerfil,price:'R$'+data+',00'})
    }
    function RealizaPagamento(event,Array){
        event.preventDefault();
        let verificacao1 = VerificaCamposPreenchidos(Array[0]);
        let verificacao2 = VerificaCamposPreenchidos(Array[1]);
        let deuRuim = true;

        if (verificacao1 && verificacao2){
            try{
                let ano = Array[1].validadeAno.split('').splice(2);
                let card = {};
                card.card_number = Array[1].numeroCartao;
                card.card_holder_name = Array[1].nome;
                card.card_expiration_date = Array[1].validadeMes + '/' + ano[0]+ano[1];
                card.card_cvv = Array[1].codigoSeguranca;

                let cardValidations = pagarme.validate({ card: card });

                if(!captcha){
                    Toastify.error('Marque o reCAPTCHA');
                    return 0;
                }

                Object.keys(card).map(item=>{

                if(!cardValidations.card[item] ){
                        switch(item){
                            case 'card_number' : Toastify.error('Número do Cartão inválido');break;
                            case 'holder_name':Toastify.error('Nome inválido');break;
                            case 'card_expiration_date':Toastify.error('Data de vencimento inválida');break;
                            case 'card_cvv':Toastify.error('Código de segurança inválido');break;
                            default: return '';
                        }
                        return;
                    }
                });

                pagarme.client.connect({ encryption_key: 'ek_live_C68Tv4dHUWmg8yY2IXfDzSDxv6nATk' })
                .then(client => client.security.encrypt(card))
                .then(card_hash =>{
                    debugger
                    ProcessaPagamento(card_hash)});


                // Toastify.success('Enviado com sucesso');
            }catch(error){
                Toastify.warning('Em desenvolvimento')
            }
        }
    }

    function VerificaCamposPreenchidos(obj){

        let verificacao = true;
        Object.keys(obj).map(item=>{
            if(obj[item]==''){
                Toastify.error(`Preencha o campo: ${item}`);
                verificacao = false;
                return;
            }
        })
        if(!verificacao)
        return false
        else return true
    }

    function VerificaMesCartao(int){
        if(int < 13 && int > 0){
            if(int < 10){
                console.log(int.length)
                if(int.length <= 1){

                    setDadosPagamento({...dadosPagamento,validadeMes:0+int})
                }
            }
        }else{
            if(dadosPagamento.validadeMes !== '')
            Toastify.error('Mês inválido')
            setDadosPagamento({...dadosPagamento,validadeMes:''})
        }
    }

    function ProcessaPagamento(card_hash){
        let aniversario = dadosPagador.nascimento;
        let tipo = '';
        let doctipo = '';

        if(dadosPagador.cpfcnpj.length ==11){
            tipo = 'individual';
            doctipo = 'cpf';
        }else{
            tipo="corporation";
            doctipo = "cnpj";
        }

        let obj={
            card_hash:card_hash,
            amount:'9',
            // dadosPerfil.price,
            installments: dadosPagamento.parcelas,
            customer:{
                external_id:0,
                name:dadosPerfil.nome,
                country:'br',
                email:dadosPagador.email,
                type:tipo,
                documents:[{
                    type:doctipo,
                    number:dadosPagador.cpfcnpj
                }],
                phone_numbers:['55' + dadosPagador.telefone],
                birthday: aniversario
            },
            billing:{
                name:dadosPagador.nomeCompleto,
                address:{
                    country:'br',
                    street:dadosPagador.logradouro,
                    city:dadosPagador.cidade,
                    state:dadosPagador.estado,
                    neighborhood:dadosPagador.bairro,
                    zipcode:dadosPagador.cep,
                    street_number:dadosPagador.numero,
                }
            },
            items:[{
                id:'999999',
                title:'Consulta Médica',
                unit_price:dadosPerfil.price,
                quantity:1,
                tangible:true,
            }],
            split_rules:[{
                recipient_id:'re_ck8yja69b2u9klf63liulgj0m',
                percentage:100,
                liable: true,
                charge_processing_fee:true
            }],
            captcha:captcha,
        }

        api.post(TesteURL + '/createtransaction', obj).then(
            function (response){
                if (response.status ===200){
                    let resultado = response.data;
                    switch(response.status){
                        case 'paid' : Toastify.success('Pagamento efetuado com sucesso'); break;
                        case 'refused' : Toastify.success('Pagamento recusado'); break;
                        default  : return '';
                    }
                    UpdateStatus();
                }else{

                }
            },function (error){
                if(error.status === 401){
                    console.log(error);
                }else{
                    Toastify.error('Não foi possível realizar, transação');
                    console.log(error);
                }
            }
        )

    }

    function buscacep(dados){

        if (dados.length < 8) {
            if (dados == ''){
                return 0;
            }
            Toastify.error('CEP inválido')
            return 0;
        }else{
            api.get('https://api.pagar.me/1/zipcodes/'+dados).then(
            function (response){
                debugger
                if (response.status === 200) {
                    setDadosPagador(
                        {
                            ...dadosPagador,
                            logradouro:response.data.street,
                            bairro:response.data.neighborhood,
                            estado:response.data.state,
                            cidade:response.data.city,
                        }
                    )
                    Toastify.success('Endereço carregado');
                }

            }
            ).catch(
                (error)=>{
                    Toastify.error('Não foi possível carregar o cep ou cep não encontrado')
                }
            )
        }



    }



    function UpdateStatus(){
        let obj = {
            // Localizador:$scope.localizador,
            // Status: $scope.resultado.status,
            // TID:$scope.resultado.tid,
            // PaidValue:$scope.solicitacao.Value,
            // AuthorizationCode:$scope.resultado.authorization_code,
        };

        // if($scope.resultado.status != 'paid'){
        //     obj.PaidValue = 0;
        // }

        api.post(TesteURL +'/updatestonestatus', obj).then(function (response){
            if(response.status == 200){
                // if($scope.resultado.status == 'paid'){
                    //redirecionar para a pagina de pagamento feito com sucesso.
                // }
            }
        }, function (error){
            if(error.status ===401){
                Toastify.error('Erro 401 no update');
            }else{
                Toastify.error('Incapaz de processar a transação');
                console.log(error.responseText);
                //redirecionar para tela de erro de transação (implementar)
            }
        })
    }

    const Logo = require('../../assets/images/logo_200_social.jpg')

    function TesteSelect(){

        Toastify.success('trocou')
    }

    useEffect(() => {
        PegaValorAPagar();

    }, [])

    return(
        <div style={{width:'100%',height:'calc(100vh - 100px)',}}>
            <Cabecalho >
                <img style={{width:'fit-content'}} src={Logo} />
                <h3>Solicitação de pagamento</h3>
                <div style={{margin:'10px 0'}}><span style={{marginRight:'10px'}}>Nome:</span>{dadosPerfil.nome}</div>
                <div style={{marginBottom:'10px'}}><span style={{marginRight:'10px'}}>Total a pagar:</span>{dadosPerfil.price}</div>
                <div>
                        <span>Nº de parcelas</span>
                    <select onChange={(event)=>{setDadosPagamento({...dadosPagamento,parcelas:event.target.value})}} style={{width:'50px',marginLeft:'10px'}} >
                        <option value='1'>01</option>
                        <option value='2'>02</option>
                        <option value='3'>03</option>
                        <option value='4'>04</option>
                        <option value='5'>05</option>
                        <option value='6'>06</option>
                        <option value='7'>07</option>
                        <option value='8'>08</option>
                        <option value='9'>09</option>
                        <option value='10'>10</option>
                        <option value='11'>11</option>
                        <option value='12'>12</option>
                    </select>
                </div>
            </Cabecalho>
            <DadosPagamento onSubmit={(event)=>RealizaPagamento(event,[dadosPagador,dadosPagamento])}>
                <span>Número do Cartão</span>
                <Input placeholder='Número do Cartão (somente os números).' type='text'
                    value={dadosPagamento.numeroCartao}
                    onChange={(event)=>setDadosPagamento({...dadosPagamento,numeroCartao:event.target.value.replace(/\D/g,'')})} />
                <span>Nome</span>
                <Input placeholder='Nome' type='text'
                    value={dadosPagamento.nome}
                    onChange={(event)=>setDadosPagamento({...dadosPagamento,nome:event.target.value.replace(/\d/g,'')})} />
                <span>Validade</span>
                <div>
                    <Input placeholder='Mês' style={{width:'50px',marginRight:'20px'}} type='text'
                        maxLength='2'
                        value={dadosPagamento.validadeMes}
                        onBlur={()=>VerificaMesCartao(dadosPagamento.validadeMes)}
                        onChange={(event)=>setDadosPagamento({...dadosPagamento,validadeMes:event.target.value.replace(/\D/g,'')})} />
                    <Input placeholder='Ano' style={{width:'70px'}} type='text'  maxLength='4'
                        value={dadosPagamento.validadeAno}
                        onChange={(event)=>setDadosPagamento({...dadosPagamento,validadeAno:event.target.value.replace(/\D/g,'')})} />
                </div>
                <span>Código de Segurança</span>
                <Input placeholder='CVV' style={{width:'50px'}} type='text'  maxLength='3'
                    value={dadosPagamento.codigoSeguranca}
                    onChange={(event)=>setDadosPagamento({...dadosPagamento,codigoSeguranca:event.target.value.replace(/\D/g,'')})} />
                <span>Nome Completo</span>
                <Input placeholder='Nome Completo' type='text'
                    value={dadosPagador.nomeCompleto}
                    onChange={(event)=>setDadosPagador({...dadosPagador,nomeCompleto:event.target.value.replace(/\d/g,'')})} />
                <span>CPF/CNPJ</span>
                <Input placeholder='CPF/CNPJ' type='text'
                    value={dadosPagador.cpfcnpj}
                    onChange={(event)=>setDadosPagador({...dadosPagador,cpfcnpj:event.target.value.replace(/\D/g,'')})} />
                <span>Data de Nascimento</span>
                <Input style={{width:'160px'}} type='date'
                     value={dadosPagador.nascimento}
                    onChange={(event)=>setDadosPagador({...dadosPagador,nascimento:event.target.value})} />
                <span>Email</span>
                <Input placeholder='Email' type='text'
                    value={dadosPagador.email}
                    onChange={(event)=>setDadosPagador({...dadosPagador,email:event.target.value})} />
                <span>Telefone</span>
                <Input placeholder='Telefone' type='text'
                    value={dadosPagador.telefone}
                    onChange={(event)=>setDadosPagador({...dadosPagador,telefone:event.target.value})}/>
                <span>CEP</span>
                <Input placeholder='CEP' type='text'
                    value={dadosPagador.cep}
                    onChange={(event)=>setDadosPagador({...dadosPagador,cep:event.target.value.replace(/\D/g,'')})}
                    onBlur={(event)=>{buscacep(event.target.value)}} />
                <span>Logradouro (Rua, Avenida,..)</span>
                <Input placeholder='Logradouro' type='text'
                    value={dadosPagador.logradouro}
                    onChange={(event)=>setDadosPagador({...dadosPagador,logradouro:event.target.value})} />
                <span>Número</span>
                <Input placeholder='N°' style={{width:'50px'}} type='text' maxLength='5'
                    value={dadosPagador.numero}
                    onChange={(event)=>setDadosPagador({...dadosPagador,numero:event.target.value})} />
                <span>Bairro</span>
                <Input placeholder='Bairro' type='text'
                    value={dadosPagador.bairro}
                    onChange={(event)=>setDadosPagador({...dadosPagador,bairro:event.target.value})} />
                <span>Cidade</span>
                <Input placeholder='Cidade' type='text'
                    value={dadosPagador.cidade}
                    onChange={(event)=>setDadosPagador({...dadosPagador,cidade:event.target.value})} />
                <span>Estado</span>
                <Input placeholder='UF' style={{width:'50px'}} type='text' maxLength='2'
                    value={dadosPagador.estado}
                    onChange={(event)=>setDadosPagador({...dadosPagador,estado:event.target.value.toUpperCase().replace(/\d/g,'')})} />
                <div style={{margin:'10px 0',display:'flex',justifyContent: 'center'}}>
                    <Recaptcha
                    sitekey='6LfrDqgZAAAAABATEykmT5tqdYVnvx0B7Fm3Ahj3'
                    onChange={(event)=>setCaptcha(event)}
                    />
                </div>
                <div style={{width: 'auto',display: 'flex',justifyContent: 'center',margin: '10px 0',}}>
                    <Button style={{width:'fit-content',height:'40px',marginBottom:window.screen.width > 800 ? '':'40px'}}
                        type='submit'>
                        <SpanButton style={{fontSize:'16px'}}>Realizar Pagamento</SpanButton>
                    </Button>
                </div>

            </DadosPagamento>

        </div>
    )
}
